import { cssJoin } from './join';

/**
 * @deprecated Use `cssJoin` instead.
 */
const clsx = cssJoin;
export { cssJoin, clsx };
export { cssMerge } from './merge';
